import React, { useEffect, useState } from "react"
import "./ProfileScreen.css"
import Nav from "../components/Nav"
import CosmosBackground from "../components/CosmosBackground"
import { useSelector, useDispatch } from "react-redux"
import { getUser, logout } from "../app/features/userSlice"
import requests from "../api/requests"
import { useSnackbar } from "react-simple-snackbar"
import { errorSnackBar, successSnackBar } from "../components/snackBarOptions"
import { useNavigate } from "react-router-dom"
import FormInput from "../components/FormInput"
import Button from "../components/Button"
import { faLock } from "@fortawesome/free-solid-svg-icons"
import { Skeleton } from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"

const getInitials = (name) => {
  if (!name) return "?"
  const parts = name.trim().split(" ")
  return parts.length > 1
    ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    : parts[0][0].toUpperCase()
}

function ProfileScreen() {
  const user = useSelector(getUser)
  const dispatch = useDispatch()
  const [openErrorSnackbar] = useSnackbar(errorSnackBar)
  const [openSuccessSnackbar] = useSnackbar(successSnackBar)
  const navigate = useNavigate()

  const [values, setValues] = useState({ password: "", confirmPassword: "" })
  const [isLoading, setIsLoading] = useState(false)

  const [subscription, setSubscription] = useState(null)
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(true)

  useEffect(() => {
    if (!user) navigate("/")
  }, [user, navigate])

  useEffect(() => {
    requests
      .getUserSubscription()
      .then((res) => setSubscription(res.data))
      .catch(() => {})
      .finally(() => setIsLoadingSubscription(false))
  }, [])

  const renewalDate = subscription?.currentPeriodEnd
    ? new Date(subscription.currentPeriodEnd * 1000).toLocaleDateString("pt-BR")
    : null

  const isActive = subscription?.status === "active"
  const statusLabel = isActive ? "Ativo" : "Inativo"

  const inputs = [
    {
      id: 1,
      name: "password",
      type: "password",
      placeholder: "Nova Senha",
      errorMessage: "Mínimo de 8 caracteres",
      label: "Senha",
      pattern: ".{8,}",
      required: true,
      icon: faLock,
    },
    {
      id: 2,
      name: "confirmPassword",
      type: "password",
      placeholder: "Repita a nova senha",
      errorMessage: "As senhas não são iguais",
      label: "Repita a senha",
      pattern: values.password
        ? `^${values.password.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}$`
        : "",
      required: true,
      icon: faLock,
    },
  ]

  const onChange = (e) => setValues({ ...values, [e.target.name]: e.target.value })

  const handleUpdatePassword = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      await requests.updatePassword(values)
      openSuccessSnackbar("Senha alterada com sucesso")
      navigate("/")
    } catch {
      openErrorSnackbar("Ocorreu um erro inesperado")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="profileScreen">
      <CosmosBackground />
      <Nav />
      <div className="profileScreen__body">

        <button className="profileScreen__back" onClick={() => navigate("/")}>
          <div className="episodeScreen__back">
            <ArrowBackIcon /> Voltar
          </div>
        </button>

        {/* Header */}
        <div className="profileScreen__header">
          <div className="profileScreen__avatar">
            {getInitials(user?.name)}
          </div>
          <div className="profileScreen__header-info">
            <h1 className="profileScreen__name">{user?.name}</h1>
            <p className="profileScreen__email">{user?.email}</p>
          </div>
        </div>

        {/* Subscription card skeleton */}
        {isLoadingSubscription && (
          <div className="profileScreen__card">
            <Skeleton variant="text" width="40%" height={16} style={{ borderRadius: 4 }} />
            <div className="profileScreen__card-row">
              <Skeleton variant="text" width="25%" height={18} />
              <Skeleton variant="text" width="18%" height={24} style={{ borderRadius: 99 }} />
            </div>
            <div className="profileScreen__card-row">
              <Skeleton variant="text" width="30%" height={18} />
              <Skeleton variant="text" width="22%" height={18} />
            </div>
            <Skeleton variant="rect" width={130} height={36} style={{ borderRadius: 8, marginTop: 2, alignSelf: "flex-end" }} />
          </div>
        )}

        {/* Subscription card */}
        {!isLoadingSubscription && subscription && (
          <div className="profileScreen__card">
            <h2 className="profileScreen__card-title">Assinatura</h2>
            <div className="profileScreen__card-row">
              <span>Status</span>
              <span className={`profileScreen__status ${isActive ? "profileScreen__status--active" : "profileScreen__status--inactive"}`}>
                {statusLabel}
              </span>
            </div>
            {renewalDate && (
              <div className="profileScreen__card-row">
                <span>Renovação</span>
                <span>{renewalDate}</span>
              </div>
            )}
            <button
              className="profileScreen__portal-btn"
              onClick={() => navigate("/subscription")}
            >
              Gerenciar assinatura →
            </button>
          </div>
        )}

        {/* Change password card */}
        <div className="profileScreen__card">
          <h2 className="profileScreen__card-title">Alterar Senha</h2>
          <form onSubmit={handleUpdatePassword} noValidate autoComplete="off">
            {inputs.map((input) => (
              <FormInput
                key={input.id}
                {...input}
                value={values[input.name]}
                onChange={onChange}
              />
            ))}
            <Button text="Salvar" isLoading={isLoading} />
          </form>
        </div>

        {/* Logout */}
        <button
          className="profileScreen__logout-btn"
          onClick={() => { dispatch(logout()); navigate("/") }}
        >
          Sair da conta
        </button>

      </div>
    </div>
  )
}

export default ProfileScreen
